export default {
  expo: {
    name: "Open House by Brivity",
    slug: "open-house",
    version: "2.3.1",
    orientation: "portrait",
    icon: "./assets/icon.png",
    userInterfaceStyle: "automatic",
    scheme: "brivityopenhouse",
    splash: {
      image: "./assets/splash.png",
      resizeMode: "contain",
      backgroundColor: "#ffffff",
    },
    assetBundlePatterns: ["**/*"],
    ios: {
      supportsTablet: true,
      userInterfaceStyle: "automatic",
      bundleIdentifier: "com.brivity.openhouse",
      entitlements: {
        "aps-environment": "development",
        "com.apple.developer.associated-domains": [
          "applinks:openhouse.brivity.com",
          "applinks:openhouse.staging.brivity.com",
        ],
      },
      infoPlist: {
        NSLocationWhenInUseUsageDescription:
          "Your location helps keep your open house details accurate and tied to the right property.",
        LSMinimumSystemVersion: "12.0",
        ITSAppUsesNonExemptEncryption: false,
        UIFileSharingEnabled: true,
        LSSupportsOpeningDocumentsInPlace: true,
        CFBundleURLTypes: [
          {
            CFBundleURLSchemes: ["brivityopenhouse"],
            CFBundleURLName: "com.brivity.openhouse",
          },
        ],
      },
    },
    android: {
      adaptiveIcon: {
        foregroundImage: "./assets/icon.png",
        backgroundColor: "#ffffff",
      },
      userInterfaceStyle: "light",
      package: "com.brivity.openhouse",
      permissions: [
        "ACCESS_FINE_LOCATION",
        "ACCESS_COARSE_LOCATION",
      ],
      intentFilters: [
        {
          action: "VIEW",
          data: [
            {
              scheme: "https",
              host: "openhouse.brivity.com",
            },
            {
              scheme: "https",
              host: "openhouse.staging.brivity.com",
            },
          ],
          category: ["BROWSABLE", "DEFAULT"],
        },
      ],
    },
    web: {
      favicon: "./assets/favicon.png",
    },
    extra: {
      eas: {
        projectId: "74cbfa34-9152-49da-ad21-c808d1e9ff6c",
      },
      OPEN_HOUSE_URL: process.env.EXPO_PUBLIC_OPEN_HOUSE_URL,
      MIDDLEWARE_URL: process.env.EXPO_PUBLIC_MIDDLEWARE_URL,
      NAVIGATION_PREFIX: process.env.EXPO_PUBLIC_NAVIGATION_PREFIX,
    },
    runtimeVersion: {
      policy: "appVersion",
    },
    updates: {
      url: "https://u.expo.dev/74cbfa34-9152-49da-ad21-c808d1e9ff6c",
    },
    owner: "brivity",
    plugins: [
      "expo-secure-store",
      [
        "onesignal-expo-plugin",
        {
          mode: "production",
        },
      ],
    ],
  },
};
